import { api } from "./api";
import {
  ProcessingLine,
  ProcessingLinePayload,
  ProcessingLinesResponse,
  ProcessingReport,
  ProcessingReportsResponse,
  ProcessingStatsResponse,
} from "../types/processing.type";

export interface ProcessingReportsFilter {
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  lineId?: string;
  warehouseMgrId?: string;
}

export const processingApi = {
  /* ── Линии ──────────────────────────────────────────────── */

  getLines: async (): Promise<ProcessingLinesResponse> => {
    const response = await api.get<ProcessingLinesResponse>("/processing/lines");
    return response.data;
  },

  createLine: async (payload: ProcessingLinePayload): Promise<ProcessingLine> => {
    const response = await api.post<ProcessingLine>("/processing/line", payload);
    return response.data;
  },

  updateLine: async (
    id: string,
    payload: Partial<ProcessingLinePayload>
  ): Promise<ProcessingLine> => {
    const response = await api.put<ProcessingLine>(`/processing/line/${id}`, payload);
    return response.data;
  },

  deleteLine: async (id: string): Promise<{ message: string }> => {
    const response = await api.delete(`/processing/line/${id}`);
    return response.data;
  },

  /* ── Загрузки ───────────────────────────────────────────── */

  getReports: async (filter: ProcessingReportsFilter = {}): Promise<ProcessingReportsResponse> => {
    const response = await api.get<ProcessingReportsResponse>("/processing/reports", {
      params: filter,
    });
    return response.data;
  },

  getReport: async (id: string): Promise<ProcessingReport> => {
    const response = await api.get<ProcessingReport>(`/processing/report/${id}`);
    return response.data;
  },

  deleteReport: async (id: string): Promise<{ message: string; warnings?: string[] }> => {
    const response = await api.delete(`/processing/report/${id}`);
    return response.data;
  },

  /* ── Статистика ─────────────────────────────────────────── */

  getStats: async (params: {
    startDate?: string;
    endDate?: string;
    lineId?: string;
  }): Promise<ProcessingStatsResponse> => {
    const response = await api.get<ProcessingStatsResponse>("/processing/stats", { params });
    return response.data;
  },
};
